var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#265FB4",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.217 7.609v8c0 .768-.623 1.391-1.391 1.391H2.39A1.391 1.391 0 0 1 1 15.609V3.783c0-.768.623-1.391 1.391-1.391h9.044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.562 9.914-2.46.984.984-2.46 6.395-6.394 1.475 1.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.956 3.52-1.475-1.476.737-.738a1.044 1.044 0 0 1 1.476 1.476l-.738.737z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFileIcon);
export default __webpack_public_path__ + "static/media/edit-file-icon.03b2e4a91174a6dca49ff2cc34bb3cb0.svg";
export { ForwardRef as ReactComponent };